export const ANSWER_COUNTER = `
  done
`;
